import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Typography, useMediaQuery } from "@mui/material";


// project imports
import NavCollapse from "./NavCollapse";

import { useRef } from "react";
import LogoSection from "../Header/LogoSection";
import Scrollbar from "../ScrollBar";
import menuItems from "./MenuItems/MenuItems";
import NavItem from "./NavItems";
import { useAuthContext } from "../../auth/hooks";

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }: any) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const trigger = useRef<any>(null);
  const sidebar = useRef<any>(null);

  const drawer = (
    <>
      <aside
        ref={sidebar}
        className={`z-20 absolute left-0 top-0 z-9999 flex h-screen w-60 flex-col overflow-y-hidden bg-[#F8F8F8] duration-300 ease-linear dark:bg-boxdark xl:static xl:translate-x-0 ${drawerOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
      >
        {/* <!-- SIDEBAR HEADER --> */}
        <div className="flex items-center justify-between gap-2 px-6 py-6 lg:py-8">
          <LogoSection />

          <button
            ref={trigger}
            onClick={drawerToggle}
            aria-controls="sidebar"
            aria-expanded={drawerOpen}
            className="block xl:hidden"
          >
            <svg
              className="fill-current"
              width="20"
              height="18"
              viewBox="0 0 20 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 8.175H2.98748L9.36248 1.6875C9.69998 1.35 9.69998 0.825 9.36248 0.4875C9.02498 0.15 8.49998 0.15 8.16248 0.4875L0.399976 8.3625C0.0624756 8.7 0.0624756 9.225 0.399976 9.5625L8.16248 17.4375C8.31248 17.5875 8.53748 17.7 8.76248 17.7C8.98748 17.7 9.17498 17.625 9.36248 17.475C9.69998 17.1375 9.69998 16.6125 9.36248 16.275L3.02498 9.8625H19C19.45 9.8625 19.825 9.4875 19.825 9.0375C19.825 8.55 19.45 8.175 19 8.175Z"
                fill=""
              />
            </svg>
          </button>
        </div>
        <Scrollbar
          component="div"
          style={{
            height: !matchUpMd ? "calc(100vh - 56px)" : "calc(100vh - 88px)",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <MenuList />
          {/* <MenuCard /> */}
          {/* <Stack direction="row" justifyContent="center" sx={{ mb: 2 }}>
          <Chip sx={{ cursor: "pointer" }} />
        </Stack> */}
        </Scrollbar>
      </aside>
      {/* <MobileView>
        <Box sx={{ px: 2 }}>
          <MenuList />
          <MenuCard />
          <Stack direction="row" justifyContent="center" sx={{ mb: 2 }}>
            <Chip label={process.env.REACT_APP_VERSION} disabled chipcolor="secondary" size="small" sx={{ cursor: 'pointer' }} />
          </Stack>
        </Box>
      </MobileView> */}
    </>
  );


  return (

    < >
      {drawer}
    </>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object,
};

export default Sidebar;

const MenuList = () => {


  const {user} = useAuthContext()
  const navItems = menuItems.items.map((item: any) => {
    const role = localStorage.getItem('roleName')    
    
    if (!item?.role?.includes(role) && !item?.role?.includes(user?.designation)) {
      return;
    }
    switch (item.type) {
      case "collapse":
        return <NavCollapse key={item.id} menu={item} level={1} />;
      case "item":
        return <NavItem key={item.id} item={item} level={1} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};
